var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrequencyBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 766.897,
    height: 766.899,
    viewBox: "0 0 766.897 766.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.2 464.806a25.82 25.82 0 0 0 18.258-44.074C83.382 369.641 51.646 297.474 51.646 232.4S83.382 95.166 134.461 44.074A25.818 25.818 0 1 0 97.945 7.565C36.616 68.894 0 152.945 0 232.4s36.616 163.513 97.945 224.842a25.691 25.691 0 0 0 18.258 7.565zm0 0",
    transform: "rotate(-45 528.99 219.115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.688 55.525a25.8 25.8 0 0 0-36.515.082C85.561 93.358 64 147.059 64 202.935s21.561 109.583 59.173 147.334a25.818 25.818 0 1 0 36.591-36.433c-28.029-28.162-44.118-68.586-44.118-110.9s16.089-82.736 44.118-110.895a25.814 25.814 0 0 0-.076-36.515zm0 0",
    transform: "rotate(-45 528.99 219.115) translate(39.292 29.465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.564 7.566a25.817 25.817 0 0 0 0 36.509c51.078 51.091 82.815 123.245 82.815 188.325s-31.737 137.241-82.815 188.331a25.818 25.818 0 1 0 36.515 36.509c61.329-61.329 97.945-145.392 97.945-224.842S401.409 68.894 340.079 7.564a25.813 25.813 0 0 0-36.515 0zm0 0",
    transform: "rotate(-45 528.99 219.115) translate(181.726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.823 357.871a25.712 25.712 0 0 0 18.3-7.6c37.612-37.751 59.173-91.452 59.173-147.334S337.73 93.356 300.118 55.605a25.818 25.818 0 1 0-36.591 36.433c28.029 28.162 44.118 68.573 44.118 110.895s-16.089 82.739-44.118 110.9a25.817 25.817 0 0 0 18.3 44.036zm0 0",
    transform: "rotate(-45 528.99 219.115) translate(157.166 29.467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.292 286.579A103.292 103.292 0 1 0 128 183.288a103.41 103.41 0 0 0 103.292 103.291zm0-154.937a51.646 51.646 0 1 1-51.646 51.646 51.7 51.7 0 0 1 51.646-51.646zm0 0",
    transform: "rotate(-45 528.99 219.115) translate(78.583 49.113)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequencyBg);
export default __webpack_public_path__ + "static/media/frequencyBg.6658f86e2274d4144d5e62bcfc949215.svg";
export { ForwardRef as ReactComponent };